import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HeadersService } from '../headers/headers.service';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { DbPrompt, Prompt } from '../../../../models/prompt';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ApiPromptsService {

  constructor(private http: HttpClient,
              private headersService: HeadersService) {
  }

  retrievePrompts(): Observable<Prompt[]> {
    return this.http
      .post<DbPrompt>(
        `${environment.explainApiUrl}prompts`,
        {'filters': {}},
        this.headersService.httpHeaders
      ).pipe(
        map((data: any) => {
          return data['data'].map((dbPrompt: DbPrompt) => {
            return new Prompt(dbPrompt);
          });
        }));
  }
}



